import React from "react";
import { useTranslation } from "react-i18next";
import { gql } from "@apollo/client";
import DeviceStatisticTemplate from "./DeviceStatisticTemplate";
import { formatToLocalTime } from "../utils/dateUtils";
import ResponsiveSelect from "../components/ResponsiveSelect";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const PAGINATE_DEVICE_ALARM = gql`
    query PaginateDeviceAlarm(
        $pagination: Pagination!
        $sortBy: [SortBy!]
        $criteria: DeviceAlarmCriteria
    ) {
        paginateDeviceAlarm(
            pagination: $pagination
            sortBy: $sortBy
            criteria: $criteria
        ) {
            pageInfo {
                totalElements
                totalPages
                numberOfElements
                pageNumber
                pageSize
            }
            content {
                id
                deviceType
                device
                serialNumber
                location
                locationName
                customer
                customerName
                reseller
                resellerName
                type
                firstSeen
                lastSeen
                updatedTimestamp
                deleted
            }
        }
    }
`;



export default function Alarm() {
    const { t } = useTranslation();

    const columns = [
        { field: "serialNumber", label: t("alarm.columns.serial"), sortable: true },
        { field: "deviceType", label: t("alarm.columns.deviceType"), sortable: true },
        { field: "type", label: t("alarm.columns.alarmType"), sortable: true,format: (v) => (v ? t(`alarm.types.${v}`) : "-") },

        { field: "resellerName", label: t("alarm.columns.reseller"), sortable: true },
        { field: "customerName", label: t("alarm.columns.customer"), sortable: true },
        { field: "locationName", label: t("alarm.columns.location"), sortable: true },

        {
            field: "firstSeen",
            label: t("alarm.columns.firstSeen"),
            sortable: true,
            format: (v) => (v ? formatToLocalTime(v) : "-"),
            nowrap: true,
            width: 160,
        },
        {
            field: "lastSeen",
            label: t("alarm.columns.lastSeen"),
            sortable: true,
            format: (v) => (v ? formatToLocalTime(v) : "-"),
            nowrap: true,
            width: 160,
        },
        {
            field: "updatedTimestamp",
            label: t("alarm.columns.updated"),
            sortable: true,
            format: (v) => (v ? formatToLocalTime(v) : "-"),
            nowrap: true,
            width: 160,
            sticky: "right",
        },
    ];

 

    return (
        <DeviceStatisticTemplate
            title={t("alarm.title")}
            subtitle={t("alarm.subtitle")}
            query={PAGINATE_DEVICE_ALARM}
            columns={columns}
            icon={<NotificationsActiveIcon />}
            isAlarmPage={true}

            
        />
    );
}
